import { notEmpty } from '@eturi/util'
import sortBy from 'lodash/sortBy.js'
import { createSelector } from 'reselect'
import type { WithOnboardingState } from '../reducers/onboarding.slice.js'
import type { OnboardingConcern } from '../types/Onboarding.js'

/**
 * NOTE: These are not necessarily compound selectors, but they dervice from `fetchSystemInfo`,
 * which is used by multiple slices. That thunk is going to use state selectors, while the slices
 * are going to use `fetchSystemInfo`. This avoids circular dependencies.
 */
const state$ = <T extends WithOnboardingState>(s: T) => s.onboarding
export const onboarding$ = /*@__PURE__*/ createSelector(state$, (s) => s.onboarding)

export const hasOnboardingUsers$ = /*@__PURE__*/ createSelector(state$, (s) =>
	notEmpty(s.data.users),
)
export const hasOnboardingUserConcerns$ = /*@__PURE__*/ createSelector(state$, (s) =>
	notEmpty(s.data.concerns),
)
export const onboardingAvailableConcerns$ = /*@__PURE__*/ createSelector(
	state$,
	(s): OnboardingConcern[] => sortBy(s.onboarding?.concerns || [], 'order'),
)

export const onboardingUserConcerns$ = /*@__PURE__*/ createSelector(state$, (s) => s.data.concerns)
export const onboardingUsers$ = /*@__PURE__*/ createSelector(state$, (s) =>
	Object.values(s.data.users),
)
export const isOnboardingInit$ = /*@__PURE__*/ createSelector(state$, (s) => s.onboarding != null)
